export default "__VITE_ASSET__f4542460__"